import React from 'react';

import {buildCatalogMap, getParents} from '../../lib/catalog';
import {default as CatalogInput2} from '../CatalogInput';

function CatalogInput({id, label, catalog, values, onChange, invalid}) {
  const catalogById = buildCatalogMap(catalog);
  let value = null;

  if (values[0]) {
    const ids = values[0].split(',');
    value = ids[ids.length - 1];
  }

  return (
    <CatalogInput2
      id={id}
      label={label}
      catalog={catalog}
      value={value}
      onChange={itemId => {
        const item = catalogById[itemId];
        const parents = getParents(item, catalogById).reverse();

        onChange([[...parents, item].map(item => item.id).join(',')], true);
      }}
      invalid={invalid}
    />
  );
}

export default CatalogInput;
